<template>
	<qrcode :value="qrcodeUrl" :options="{ size: 202 }" ></qrcode>
</template>

<script>
	import Qrcode  from '@xkeshi/vue-qrcode'
    export default {
        data(){
            return{
				
            }
        },
		
		components: {
			Qrcode
		},
		props:{
            qrcodeUrl: {
                type: String,
            },
			
			chargeMoney: {
			    type: String,
			},
			
			tips:{
				type: String,
			}
		}
    };
</script>
<style lang="scss" scoped>
	
</style>
